import { CategoryEntity } from '@shared/domain/products/category.entity';
import { ManufacturerEntity } from '@shared/domain/products/manufacturer.entity';
import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { Dictionary } from '@shared/types';
import { Field, IsObject } from '@tsim/model';
import { deburr, kebabCase } from 'lodash';

export class ProductEntity extends BaseRootEntity {
  @Field(String, false)
  ean?: string;

  @Field(String, false)
  productNumber?: string;

  @Field(String, true)
  name!: string;

  @Field(String, false)
  shortDescription?: string;

  @Field(String, false)
  description?: string;

  @Field(String, false)
  url?: string;

  @Field(Number, true)
  price = 0;

  @Field(Number, false)
  purchasePrice?: number;

  @Field(Number, false)
  standardPrice?: number;

  @Field(Boolean, false)
  includingVat = false;

  @Field(Number, false)
  percentVat = 0.21;

  @Field(Number, false)
  actionPrice?: number;

  @Field(Date, false)
  actionFrom?: Date;

  @Field(Date, false)
  actionTo?: Date;

  @Field(Number, true)
  weight = 0;

  @Field(Number, true)
  availability = 3;

  @Field(Number, true)
  stock = 0;

  @Field(Boolean, false)
  freeShipping = false;

  @Field(String, false)
  defaultImage?: string;

  @Field([String], true)
  images: string[] = [];

  @Field([String], true)
  files: string[] = [];

  @Field(Object, true, { validators: [IsObject()] })
  params: Dictionary = {};

  @Field([String], true)
  accessories: string[] = [];

  @Field(Object, true, { validators: [IsObject()] })
  dimensions = {
    length: 0,
    width: 0,
    height: 0,
  };

  @Field(String, true)
  categoryId!: string;

  @Field(String, true)
  manufacturerId!: string;

  @Field(String, false)
  categoryName = '';

  @Field(String, false)
  manufacturerName = '';

  @Field(CategoryEntity, false)
  category?: CategoryEntity;

  @Field(ManufacturerEntity, false)
  manufacturer?: ManufacturerEntity;

  @Field(Boolean, false)
  buyForbidden = false;

  get perimeter(): number {
    return this.dimensions.length * 2 + this.dimensions.width * 2;
  }

  get area(): number {
    return this.dimensions.length * this.dimensions.width;
  }

  get volume(): number {
    return this.dimensions.length * this.dimensions.width * this.dimensions.height;
  }

  get shopUrl(): string {
    return this.url || kebabCase(deburr(this.name));
  }

  get isEanValid(): boolean {
    const pattern = /^([0-9]{8}|[0-9]{13,14})$/;
    return pattern.test((this.ean ?? '').trim());
  }
}
